export const AddNewMaterialModalConsts = {
  TITLE: "Add New Material",
  LABEL: "Material Name",
  NAME: "newMaterialName",
  PLACEHOLDER: "Enter material name",
};
